var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.017 0.5C17.0053 0.5 18.617 2.11177 18.617 4.1C18.617 6.08822 17.0053 7.7 15.017 7.7C13.0288 7.7 11.417 6.08822 11.417 4.1C11.417 2.11177 13.0288 0.5 15.017 0.5ZM4.1 1.47254H9.87011C10.2015 1.47254 10.4701 1.74117 10.4701 2.07254C10.4701 2.37078 10.2525 2.61819 9.96743 2.66469L9.87011 2.67254H4.1C2.82974 2.67254 1.78998 3.65938 1.70554 4.90822L1.7 5.07254V11.9918C1.7 13.262 2.68684 14.3018 3.93568 14.3862L4.1 14.3918H5.57472V18.0527L9.23569 14.3918H14.082C15.3523 14.3918 16.392 13.4049 16.4765 12.1561L16.482 11.9918V9.1C16.482 8.76863 16.7506 8.5 17.082 8.5C17.3802 8.5 17.6277 8.71759 17.6742 9.00268L17.682 9.1V11.9918C17.682 13.9159 16.1725 15.4874 14.2732 15.5868L14.082 15.5918H9.73275L6.25254 19.072C6.04625 19.2783 5.76646 19.3942 5.47472 19.3942C4.90771 19.3942 4.4409 18.9652 4.38118 18.414L4.37472 18.2942V15.5918H4.1C2.17591 15.5918 0.604377 14.0823 0.50499 12.183L0.5 11.9918V5.07254C0.5 3.14845 2.00947 1.57692 3.90881 1.47753L4.1 1.47254ZM12.617 4.1C12.617 2.77452 13.6915 1.7 15.017 1.7C16.3425 1.7 17.417 2.77452 17.417 4.1C17.417 5.42548 16.3425 6.5 15.017 6.5C13.6915 6.5 12.617 5.42548 12.617 4.1Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnread);
export default __webpack_public_path__ + "static/media/unread.23aaeab1e3f4ff8c344d033f9c9782bf.svg";
export { ForwardRef as ReactComponent };